var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:['annotation-el', 'annotation', 'annotation-image', _vm.selected ? 'selected': '', _vm.moveMode ? 'no-cursor': ''],style:(_vm.elStyle),attrs:{"draggable":"false","src":'/static/' + _vm.name + '.svg'},on:{"click":_vm.showControls}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-439939a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/annotations/AnnotationImage.vue
// module id = kyx1
// module chunks = 1